



















































import { defineComponent, watch } from "@vue/composition-api";
import {
  InHouseOtherCompetitors,
  NotificationFilterCategory
} from "@/api/types";
import { getNewExperiences } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import Section from "../../Molecules/Section/index.vue";
import LineClamp from "@/components/Atoms/Typography/LineClamp/index.vue";
import { useRouter } from "@/router";

export default defineComponent({
  name: "AttentionReviews",
  components: {
    Heading,
    Caption,
    Section,
    LineClamp
  },
  setup(_, { emit }) {
    const router = useRouter();
    const [
      { data: experiences, loading: attentionReviewsLoading }
    ] = useRequest(() => getNewExperiences(), {
      immediate: true
    });

    watch(attentionReviewsLoading, newValue => {
      emit("changeAttentionReviewsLoading", newValue);
    });

    const itemClass = (label: string) => {
      if (label === InHouseOtherCompetitors.InHouse) {
        return "attentionReviews__item--inHouse";
      } else {
        return "attentionReviews__item--competitors";
      }
    };

    const notificationFilterCategory = NotificationFilterCategory;

    const handleClickReviewsMore = () => {
      const reviewsMoreRoute = router.resolve({
        name: "Notifications",
        query: {
          category: notificationFilterCategory.EXPERIENCE
        }
      });
      window.open(reviewsMoreRoute.href, "_blank", "noopener");
    };

    return {
      experiences,
      attentionReviewsLoading,
      itemClass,
      notificationFilterCategory,
      handleClickReviewsMore
    };
  }
});
